import React from "react"
import {Tabs} from 'antd'
import BigPicture from 'bigpicture'
import "./section2.scss"
import data from "../data.json"

const {TabPane} = Tabs;

const tabs = data.workstab

class Section2 extends React.Component {

    render() {
        return (
            <div className={"tap-panel"}>
                <Tabs tabPosition={"left"}>
                    {
                        tabs.map((item, index) => {
                            return <TabPane tab={
                                <>
                                    <div className="title">{item.title}</div>
                                    <div className="subtitle">{item.subtitle}</div>
                                </>
                            } key={index}>
                                <ul>{
                                    item.works.map((work, workIndex) => {
                                        return (
                                            <li onClick={(e) => {
                                                if (work.link) {
                                                    window.open(work.link)
                                                } else if (work.contentvideo) {
                                                    BigPicture({
                                                        el: e.target,
                                                        vidSrc: work.contentvideo,
                                                    })
                                                } else {
                                                    BigPicture({
                                                        el: e.target,
                                                        imgSrc: work.content,
                                                    })
                                                }

                                            }} key={workIndex}>
                                                <img src={work.cover + "?imageView2/2/w/400"} alt=""/></li>
                                        )
                                    })
                                }
                                </ul>
                            </TabPane>

                        })
                    }

                </Tabs>
            </div>
        )
    }

}

export default Section2

